import { motion } from "framer-motion";
import { useState } from "react";
import React from 'react';
// import bgExperience from 

// const MotionLink = motion(Link);
const ListExperience = () => {
    
    const historys = [
        { title: "Kalbis University", img: "./logo/kalbis-logo.webp", position: "Programmer", time:"Apr 2023 - Now",jobdesc:"",jobdescnew:[
            {point:"Manage and develop website application",subpoints:["academic operation (leaps.kalbis.ac.id)","career alumni center (cac.kalbis.ac.id)","Room facilities (facilities.kalbis.ac.id)","company profile (kalbis.ac.id)"]},
            {point:"Implemented and provided solutions for system integration with Neo Feeder Dikt",subpoints:[]},
            {point:"Performed server analysis and monitoring to ensure optimal performance, security, and service availability",subpoints:[]},
            {point:"Set up and configured Linux-based servers",subpoints:["installing web servers (Apache/Nginx)","database servers (MariaDB/MySQL)","configuring virtual hosts","managing user permissions","configuring domain names, and implementing SSL"]},
            {point:"Prepared and presented reports for the Academic Operation Division",subpoints:[]},
            {point:"Identified, analyzed, and resolved various technical issues within the IT Division",subpoints:[]},
            {point:"Actively engaged in sharing and discussion sessions within the IT team at Phinma Education",subpoints:[]},
            // {point:"",subpoints:[]},
        ], delay: 0.5 },        
        { title: "PT Super Spring", img: "./logo/superspring-logo.webp", position: "Fullstack Developer", time:"Dec 2021 - Mar 2023",jobdescnew:[
            {   point:"Responsible for website development and ongoing maintenance to support business objectives",
                subpoints:["pulsa.gps.id","pulsa2.gps.id","s2care.gps.id","honda.gps.id"]
            }, {
                point:"Managing prepaid credit API services integrated with GPS tracker systems to ensure service continuity"   
            },{
                point:"Managing the reporting system for the GPS ID and credit top-up databases to provide summaries of service renewal and active period extensions."
            },{
                point:"Overseeing the integration of credit and GPS ID databases to ensure seamless active period extensions for GPS services"
            },{
                point:"Developing and maintaining the company website to ensure optimal performance and security."
            }
        ],jobdesc:"", delay: 0.5 },
        { title: "Badiklitpensos ministry of social affairs RI", img: "./logo/logo.png", position: "IT Staff", time:"Oct 2019 - Oct 2021",jobdesc:", , , ",jobdescnew:[
            {point:"Analyzing user requirements and providing solutions for the web application",subpoints:[]},
            {point:"Develop Internal Application Website",subpoints:[]},
            {point:"Performing computer maintenance",subpoints:[]},
            {point:"Preparing online and offline meeting rooms",subpoints:[]}
            
        ], delay: 0.5 },
        { title: "PT Astragraphia Xprins Indonesia", img: "./logo/axi-logo.webp", position: "Web Support", time:"Feb 2019 - Nov 2019",jobdescnew:[
            {
                point:"Preparing the client's website",
                subpoints:[],
            },
            {
                point:"Compiling customer data and Preparing the user manual",
                subpoints:[],
            },
            {
                point:"Processing customer orders into the internal application",
                subpoints:[],
            },
            {
                point:"Make dashboard monitoring user and customer",
                subpoints:[],
            },
            {
                point:"Make dashboard monitoring user and customer",
                subpoints:[],
            }
        ],jobdesc:"", delay: 0.5 }
    ];
    
    // const [showMore, setShowMore] = useState<Record<number, boolean>>({});
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const toggleShowMore = (index: number) => {
        // setShowMore((prev) => ({
        // ...prev,
        // [index]: !prev[index],
        // }));
        setActiveIndex(prev => (prev === index ? null : index));
    };
    
    return(
        <div className="flex md:flex-row sm:flex-col flex-col gap-6 md:w-full">
            {/* <hr className="w-1/2 border-t border-[#000000]" /> */}
            <motion.div 
            initial={{ opacity: 0, y: 50 }} // posisi awal
            whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
            viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
            className="w-full md:w-1/2 sm:w-full">
                <h3 className="text-5xl sm:text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 text-center bg-clip-text text-transparent text-balance  mt-5 tracking-tight ">
                    Experience
                </h3>
                <div className="md:bg-[#edf0f5] sm:bg-[#ffffff] rounded-xl p-4 flex items-top justify-center mt-10 mx-auto ">
                    <div className="bg-[#ffffff] ml-2 mr-2 p-8 shadow-xl rounded-lg w-full min-h-[200px]">
                    
                        <h3 className="text-lg font-semibold text-black text-xl"> </h3>
                        {activeIndex !== null ? (
                            <div className="space-y-2 text-sm text-gray-800 mt-5">
                            <h4 className="text-md sm:text-lg md:text-xl font-montserrat font-bold text-center mb-2">{historys[activeIndex].title}</h4>
                            <p className="text-center text-gray-600 text-sm sm:text-sm md:text-md font-montserrat">{historys[activeIndex].position} ({historys[activeIndex].time})</p>
                            <h4 className="mb-2 text-sm sm:text-sm md:text-md font-montserrat">Job Description</h4>
                            {historys[activeIndex].jobdescnew.map((desc, idx) => (
                                <ul key={idx}className="list-disc ml-4 tracking-tight text-[11px] sm:text-[11px] md:text-lg font-montserrat">
                                    <li >
                                        <span>{desc.point}</span>
                                        {desc.subpoints && desc.subpoints.length > 0 && (
                                        <ul className="list-[circle] ml-5 mt-1 text-gray-600 tracking-tight">
                                            {desc.subpoints.map((sub, subIdx) => (
                                            <li key={subIdx}>{sub}</li>
                                            ))}
                                        </ul>
                                        )}
                                    </li>
                                </ul>
                                ))}
                            </div>
                        ) : (
                           <div className="flex items-center justify-center">
                           <img src={"./img/cs-experience.webp"} className=" w-80 md:h-72 sm:h-auto" alt="" />
                           </div>
                            // <p className="text-gray-500 text-center">Please click "Read more" to look my detail experience</p>
                        )}
                    </div>
                </div>
            </motion.div>
            <div className="w-full md:w-1/2 sm:w-full">
            {historys.map((item, index) => (  
                <React.Fragment key={index}>
                    <motion.div  
                    initial={{ opacity: 0, y: 50 }} 
                    // animate={{ opacity: 1, y: 0 }} 
                    whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
                    viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
                    transition={{ duration: 0.6, delay: item.delay, ease: "easeOut" }} 
                     className="backdrop-blur-md rounded-3xl p-8 shadow-lg bg-white/30 p-6 bg-gradient-to-r from-[#0d3270] to-purple-600 ">
                        <div className="flex justify-center items-center gap-4">
                            <div className="flex-shrink-0 w-1/4 flex justify-center items-center">
                                <img src={item.img} alt="Company Logo" className="w-20 sm:w-20 md:w-35 rounded-full"/>
                            </div>
                            
                            <div className="bg-white p-5 rounded-xl  w-[300px] sm:w-[300px] md:w-[500px]">
                                <h3 className={`font-semibold font-montserrat text-sm md:text-xl sm:text-sm ${
                                        activeIndex === index ? 'font-montserrat font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 bg-clip-text text-transparent ' : 'text-black'}`}>{item.title}</h3>
                                <div className={` text-gray-700 gap-4 text-[11px] sm:text-[11px] md:text-sm ${
                                        activeIndex === index ? 'font-montserrat font-bold  bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 bg-clip-text text-transparent ' : 'text-black'}`}>
                                    <span> {item.position}</span>
                                    <span> ({item.time})</span>
                                </div>
                            

                                {/* Read More button */}
                                <button onClick={() => toggleShowMore(index)} className={`mt-3 text-black-600 text-[11px] sm:text-[11px] md:text-sm font-semibold hover:underline ${
                                        activeIndex === index ? 'font-montserrat font-bold  bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 bg-clip-text text-transparent ' : 'text-black'}`}>
                                    {activeIndex === index ? "Read less ↑" : "Read more →"}
                                </button>
                            </div>
                        </div>
                    </motion.div>
                    <div className="h-4"></div>
               </React.Fragment>            
            ))}
            </div>
        </div>
    );
}

export default ListExperience;